export const getInitialState = isMockedData => {
  if (isMockedData) {
    return {
      isPaymentLinkAvailable: true,
      massOffering: {
        donator_name: 'Jan Kowalski',
        content: 'Za Andrzeja w intencji zdrowia i pomyślności w życiu osobistym.',
        mass: { date: '25.03.2023', hour: 'bez godziny', public_note: 'w dolnym kościele' },
      },
      gregorianMass: {
        donatorName: 'Jan Kowalski',
        content: 'Za Andrzeja Binga.',
        dateCreated: '2023-03-25',
        dateStart: '2023-03-25',
      },
      gregorianMassAmount: {
        predefinedValues: [800, 1200, 1500],
        allowOwnAmount: true,
        minimalValue: 500,
      },
    };
  }

  return {
    isPaymentLinkAvailable:
      '{% if isPaymentLinkAvailable is defined %}{{ isPaymentLinkAvailable }}{% endif %}',
    massOffering: {
      donator_name:
        '{% if massOffering.donator_name is defined %}{{ massOffering.donator_name }}{% endif %}',
      content: '{% if massOffering.content is defined %}{{ massOffering.content }}{% endif %}',
      date_created:
        '{% if massOffering.date_created is defined %}{{ massOffering.date_created }}{% endif %}',
      mass: {
        date: '{% if massOffering.mass is defined %}{{ massOffering.mass.date }}{% endif %}',
        hour: '{% if massOffering.mass is defined %}{{ massOffering.mass.hour }}{% endif %}',
        public_note:
          '{% if massOffering.mass is defined %}{{ massOffering.mass.public_note }}{% endif %}',
      },
    },
    gregorianMass: {
      donatorName:
        '{% if gregorianMass.donator_name is defined %}{{ gregorianMass.donator_name }}{% endif %}',
      content: '{% if gregorianMass.content is defined %}{{ gregorianMass.content }}{% endif %}',
      dateCreated:
        '{% if gregorianMass.date_created is defined %}{{ gregorianMass.date_created }}{% endif %}',
      dateStart:
        '{% if gregorianMass.date_start is defined %}{{ gregorianMass.date_start }}{% endif %}',
    },
    gregorianMassAmount: {
      predefinedValues:
        '{% if gregorianMassAmount is defined %}{{ gregorianMassAmount.predefined_values|json_encode() }}{% else %}{{ null }}{% endif %}',
      allowOwnAmount:
        '{% if gregorianMassAmount is defined %}{{ gregorianMassAmount.allow_own_amount }}{% else %}{{ null }}{% endif %}',
      minimalValue:
        '{% if gregorianMassAmount is defined %}{{ gregorianMassAmount.minimal_value }}{% else %}{{ null }}{% endif %}',
    },
  };
};
